import styled from "styled-components";

export const ContentStyle = styled.div`
    border-radius: 20px;
    padding: 30px;
`;